import React from 'react';
import KardiaRxCCTPatients from '../views/pages/KardiaRxCCTPatients';
import KardiaRxCCTWorkList from '../views/pages/KardiaRxCCTWorkList';
import ROUTE_PATHS from './routePaths';
import UserProfileProvider from '../auth/contexts/UserProfileContext';

const routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CCT_PATIENTS_LIST,
    component: props => (
      <UserProfileProvider>
        <KardiaRxCCTPatients {...props} />
      </UserProfileProvider>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CCT_WORK_LIST,
    component: props => (
      <UserProfileProvider>
        <KardiaRxCCTWorkList {...props} />
      </UserProfileProvider>
    ),
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/cctRoutes.jsx